import { ComponentType } from '@angular/cdk/portal'
import { Injectable, TemplateRef } from '@angular/core'
import { take } from 'rxjs/operators'
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog'
import { LosDiscountDialogComponent, LostDiscountDialogParams } from './los-discount-dialog.component'
import { LosDiscountView } from '@tokeet-frontend/los-discount'

@Injectable()
export class LosDiscountDialogService {
  constructor(private dialog: MatDialog) {}

  private openSide<T, D = any>(
    componentOrTemplateRef: ComponentType<T> | TemplateRef<T>,
    data: { item?: Partial<LosDiscountView>; primaryBtnClass: string; cancelBtnClass: string; hasModality: boolean }
  ): MatDialogRef<T> {
    const defaultConfig: MatDialogConfig = {
      width: '100%',
      height: '100%',
      maxWidth: 'auto',
      backdropClass: '',
      position: {
        right: '0px',
        bottom: '0px',
      },
      data,
      panelClass: ['modal', 'side-modal-lg', 'modal-new-template', 'right'],
    }

    const dialogRef = this.dialog.open(componentOrTemplateRef, defaultConfig)

    if (dialogRef['_overlayRef'].overlayElement) {
      dialogRef['_overlayRef'].overlayElement.parentElement.className += ' dialog-wrapper'
    }

    dialogRef
      .beforeClosed()
      .pipe(take(1))
      .subscribe(() => {
        dialogRef['_containerInstance']['_elementRef'].nativeElement.classList.add('side-closing')
      })

    return dialogRef
  }

  open(data: LostDiscountDialogParams) {
    return this.openSide(LosDiscountDialogComponent, data)
  }
}
